const locale: Locale = {
  ko: {
    answered: '답변된 청원',
  },
  en: {
    answered: 'Responded Petitions',
  },
}

export default locale
